import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import PageLayout from "./layouts/PageLayout";
import IndexPage from "./pages/.IndexPage/IndexPage";
import AboutPage from "./pages/.AboutPage/AboutPage";
import NotFoundPage from "./pages/.NotFoundPage/NotFoundPage";
import LinkPage from "./pages/.LinkCollectionPage/LinkCollectionPage";
import ImpressumPage from "./pages/.ImpressumPage/ImpressumPage";

import SIGA01 from "./pages/SIGA/01_WolframAlpha/01_WolframAlpha";
import SIGA02 from "./pages/SIGA/02_Google_Colab/02_Google_Colab";
import SIGA03 from "./pages/SIGA/03_Audacity/03_Audacity";
import SIGA04 from "./pages/SIGA/04_Sinus_und_Kosinus/04_Sinus_und_Kosinus";
import SIGA05 from "./pages/SIGA/05_Faltung/05_Faltung";
import SIGA06 from "./pages/SIGA/06_DFT/06_DFT";
import SIGA07 from "./pages/SIGA/07_Gleitender_Mittelwert/07_Gleitender_Mittelwert";
import SIGA08 from "./pages/SIGA/08_Abtasttheorem/08_Abtasttheorem";
import SIGA09 from "./pages/SIGA/09_Leakage/09_Leakage";
import SIGA10 from "./pages/SIGA/10_Tierstimmen/10_Tierstimmen";
import SIGA11 from "./pages/SIGA/11_Erwartungswert_und_Varianz/11_Erwartungswert_und_Varianz";
import SIGA12 from "./pages/SIGA/12_Verteilungen/12_Verteilungen";
import SIGA13 from "./pages/SIGA/13_Stichprobe/13_Stichprobe";
import SIGA14 from "./pages/SIGA/14_Gezinkte_Wuerfel/14_Gezinkte_Wuerfel";
import SIGA15 from "./pages/SIGA/15_Korrelationskoeffizient/15_Korrelationskoeffizient";

import BV01 from "./pages/BV/01_Binarisierung/01_Binarisierung";
import BV02 from "./pages/BV/02_Histogrammspreizung/02_Histogrammspreizung";
import BV03 from "./pages/BV/03_BV_03/03_BV_03";
import BV04 from "./pages/BV/04_BV_04/04_BV_04";
import BV05 from "./pages/BV/05_BV_05/05_BV_05";
import BV06 from "./pages/BV/06_BV_06/06_BV_06";
import BV07 from "./pages/BV/07_BV_07/07_BV_07";
import BV08 from "./pages/BV/08_BV_08/08_BV_08";
import BV09 from "./pages/BV/09_BV_09/09_BV_09";
import BV10 from "./pages/BV/10_BV_10/10_BV_10";
import BV11 from "./pages/BV/11_BV_11/11_BV_11";
import BV12 from "./pages/BV/12_BV_12/12_BV_12";

const App = () => {
  return (
    <Router>
      <PageLayout>
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/links" element={<LinkPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />

          <Route path="/siga/01" element={<SIGA01 />} />
          <Route path="/siga/02" element={<SIGA02 />} />
          <Route path="/siga/03" element={<SIGA03 />} />
          <Route path="/siga/04" element={<SIGA04 />} />
          <Route path="/siga/05" element={<SIGA05 />} />
          <Route path="/siga/06" element={<SIGA06 />} />
          <Route path="/siga/07" element={<SIGA07 />} />
          <Route path="/siga/08" element={<SIGA08 />} />
          <Route path="/siga/09" element={<SIGA09 />} />
          <Route path="/siga/10" element={<SIGA10 />} />
          <Route path="/siga/11" element={<SIGA11 />} />
          <Route path="/siga/12" element={<SIGA12 />} />
          <Route path="/siga/13" element={<SIGA13 />} />
          <Route path="/siga/14" element={<SIGA14 />} />
          <Route path="/siga/15" element={<SIGA15 />} />
          

          <Route path="/bv/01" element={<BV01 />} />
          <Route path="/bv/02" element={<BV02 />} />
          <Route path="/bv/03" element={<BV03 />} />
          <Route path="/bv/04" element={<BV04 />} />
          <Route path="/bv/05" element={<BV05 />} />
          <Route path="/bv/06" element={<BV06 />} />
          <Route path="/bv/07" element={<BV07 />} />
          <Route path="/bv/08" element={<BV08 />} />
          <Route path="/bv/09" element={<BV09 />} />
          <Route path="/bv/10" element={<BV10 />} />
          <Route path="/bv/11" element={<BV11 />} />
          <Route path="/bv/12" element={<BV12 />} />
          
          {/* Route für nicht gefundene Seiten */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </PageLayout>
    </Router>
  );
};

export default App;
